import { render, staticRenderFns } from "./SecondaryServiceType.vue?vue&type=template&id=e9f2e48e&"
import script from "./SecondaryServiceType.vue?vue&type=script&lang=js&"
export * from "./SecondaryServiceType.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryServiceType.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports